import {
  Button,
  Grid,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';
import useOpenIntercomService from '@pages/inactiveUser/hooks/useOpenIntercomService';
import { useTranslation } from 'react-i18next';
import { zsBanner } from './assets';
import COLLECT_LOCAL_PAY_BENEFITS from './constants/CollectLocalPayBenefits.constants';

const CollectLocalPay = () => {
  const { showNewMessage } = useOpenIntercomService();
  const { t } = useTranslation();
  return (
    <TableBody>
      <TableRow>
        <TableCell colSpan={9} className="!text-center !border-b-0">
          <div className="max-w-[900px] mx-auto">
            <div className="bg-[#010D25] rounded-tr-xl rounded-tl-xl">
              <div className="flex flex-row relative">
                <div className="flex flex-col items-start justify-center gap-2 text-left px-8 py-1">
                  <Typography variant="h5" className="font-semibold text-white">
                    {t('clpHeader')}
                  </Typography>
                  <Typography variant="body2" className="text-white">
                    {t('clpDescription')}
                  </Typography>
                  <Button
                    variant="contained"
                    className="!bg-[#016bf8] !text-white !mt-4 !normal-case"
                    onClick={() => {
                      showNewMessage(t('clpIntercomMessage') as string);
                    }}
                  >
                    {t('clpActionBtn')}
                  </Button>
                </div>
                <img
                  className="h-full w-auto max-w-[350px] z-0 hidden sm:block rounded-tr-xl"
                  src={zsBanner}
                  alt="Collect local payment banner"
                />
              </div>
            </div>
            <Grid
              container
              className="border-[#ECECEC] border-solid border py-3 text-left"
            >
              {COLLECT_LOCAL_PAY_BENEFITS.map((item) => (
                <Grid
                  key={item.description}
                  item
                  xs={12}
                  lg={3}
                  className="border-[#ECECEC] border-solid border-r p-3 text-left"
                >
                  {item.icon}
                  <Typography variant="body2">{t(item.description)}</Typography>
                </Grid>
              ))}
            </Grid>
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell>
          <Typography
            variant="caption"
            className="text-center mt-4 text-[#9F9F9F]"
          >
            {t('clpDisclaimer')}
          </Typography>
        </TableCell>
      </TableRow>
    </TableBody>
  );
};

export default CollectLocalPay;
